import app from '@/app';

/* @ngInject */
const resource = abstractResource => abstractResource('metrics/limit');

app.factory('MetricLimit', resource);
